import { render, staticRenderFns } from "./EditorSelect.vue?vue&type=template&id=5822171f&scoped=true"
import script from "./EditorSelect.vue?vue&type=script&lang=js"
export * from "./EditorSelect.vue?vue&type=script&lang=js"
import style0 from "./EditorSelect.vue?vue&type=style&index=0&id=5822171f&prod&lang=scss"
import style1 from "./EditorSelect.vue?vue&type=style&index=1&id=5822171f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5822171f",
  null
  
)

export default component.exports